import DashBoardManager from './DashBoardManager';

export default DashBoardManager;
